const { env } = require('./const')
const crypto = require('crypto-js')

export const encrypt = async (
  text,
  secret = env.REACT_APP_PASSWORD_MASK_SECRET
) => {
  return crypto.AES.encrypt(text, secret).toString()
}
